import api, { Notifiable } from '../api';
import { CrfPedidoFormulario } from './crfContratadoPcm';

const controller = 'crfContratoPcs';

export interface CrfDistribuicao {
    //distribuicaoItemResult: ContratadoAno[];
    resultDataTabel: CrfContratadoAno[];
    anos: number[];
}

export interface CrfContratadoAno {
    pcmId: string;
    requisicaoCompraSeqId: string;
    crfContaContabilCcId: string;
    moduloEconomicoContratadoId: string;
    ordemCompraId: string;

    crfContaContabilCcRcSeqId: string;
    crfContaContabilCcRequisicaoCompraSeqPrincial: boolean;

    numeroOrdemInvestimento: string;

    pacoteProjeto: string;
    pacotePctOi: string;

    requisicaoCompraNumero: number;
    requisicaoCompraSeq: string;
    requisicaoCompraPrecoUnitarioFormatado: string;
    requisicaoCompraPrecoUnitario: number;
    requisicaoCompraQuantidadeTotal: string;
    requisicaoCompraValorTotal: number;
    requisicaoCompraValorTotalFormatado: string;
    requisicaoCompraOc: string;

    pedidoPcm: string;
    pedidoCtPcs: string;
    pedidoCtPreUnitarioFormatado: string;
    valorUnitarioPedido: number;

    valorFormatado: string;
    quantidadeFormatado: string;
}

export interface CrfPedidoServicoResult extends Notifiable {
    row: number;
    id: string;
    crfContaContabilCcRcSeqId: string;
    agrupador: string;
    contaContabilCodigo: string;
    contaContabilNome: string;
    ocData: string;
    ocNumero: string;
    ocNumeroFormatado: string;
    pacoteCodigo: string;
    pacoteNome: string;
    pacoteNumero: string;
    projetoNome: string;
    projetoNumero: string;
    projetoNumeroInt: string;
    rcNarrativa: string;
    rcNumero: string;
    rcNumeroFormatado: string;
    rcSeq: string;
    rcSeqFormatado: string;
    rcStatus: string;
}

export const obterNarativaPorCrfContaContabilCcRequisicaoCompraSeqId = (id: any) =>
    api.get<string>(`${controller}/obterNarativaPorCrfContaContabilCcRequisicaoCompraSeqId/${id}`);

export const getAllCrfContratoAno = (crfContaContabilCcRequisicaoCompraSeqId: any) =>
    api.get<CrfDistribuicao>(`${controller}/getAllContratoAno/${crfContaContabilCcRequisicaoCompraSeqId}`);

export const getFilterPedidoServico = (values: CrfPedidoFormulario) => {
    var query = "";

    query += values.numeroCentroCustoFormulario ? "numeroCentroCusto=" + values.numeroCentroCustoFormulario : "";
    query += values.codigoCentroCustoFormulario ? "&codigoCentroCusto=" + values.codigoCentroCustoFormulario : "";
    query += values.nomeCentroCustoFormulario ? "&nomeCentroCusto=" + values.nomeCentroCustoFormulario : "";
    query += values.statusModuloEconomicoFormulario ? "&statusModuloEconomico=" + values.statusModuloEconomicoFormulario.join('&statusModuloEconomico=') : "";

    query += values.acronimoAgrupadorFormulario ? "&acronimoAgrupador=" + values.acronimoAgrupadorFormulario : "";
    query += values.codigoAgrupadorFormulario ? "&codigoAgrupador=" + values.codigoAgrupadorFormulario : "";
    query += values.codigoContaContabilFormulario ? "&codigoContaContabil=" + values.codigoContaContabilFormulario : "";

    query += values.numeroRequisicaoCompraFormulario ? "&numeroRequisicaoCompra=" + values.numeroRequisicaoCompraFormulario : "";
    query += values.numeroItemRequisicaoCompraFormulario ? "&numeroItemRequisicaoCompra=" + values.numeroItemRequisicaoCompraFormulario : "";
    query += values.statusRequisicaoCompraFormulario ? "&statusRequisicaoCompra=" + values.statusRequisicaoCompraFormulario.join('&statusRequisicaoCompra=') : "";
    query += values.dataRequisicaoCompraFormulario ? "&dataRequisicaoCompra=" + values.dataRequisicaoCompraFormulario : "";

    query += values.numeroOrdemCompraFormulario ? "&numeroOrdemCompra=" + values.numeroOrdemCompraFormulario : "";
    query += values.dataEmissaoOrdemCompraFormulario ? "&dataEmissaoOrdemCompra=" + values.dataEmissaoOrdemCompraFormulario : "";

    query += values.numeroPedidoCompraFormulario ? "&numeroPedidoCompra=" + values.numeroPedidoCompraFormulario : "";
    query += values.tipoPedidoCompraFormulario ? "&tipoPedidoCompra=" + values.tipoPedidoCompraFormulario : "";
    query += values.nomeFornecedorPedidoCompraFormulario ? "&nomeFornecedorPedidoCompra=" + values.nomeFornecedorPedidoCompraFormulario : "";
    query += values.dataPedidoCompraFormulario ? "&dataPedidoCompra=" + values.dataPedidoCompraFormulario : "";

    query += values.numeroContratoPcsFormulario ? "&numeroContratoPcs=" + values.numeroContratoPcsFormulario : "";

    query = query.replace(/^&/, '');
    return api.get<CrfPedidoServicoResult[]>(`${controller}/servicos?${query}`);
};


